module.exports = __webpack_public_path__ + "r-v3/img/user1.29fef655.svg";